import { moduleFactory } from "@/factories/module";
import { initializeLowlight } from "@/modules/lowlight/initialize";

export const lowlightModule = moduleFactory.create({
  initialize: initializeLowlight,
});
